import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["pane", "zettelSlugs"];

  connect() {
    // Initialize with current URL params
    this.updateZettelSlugs();

    // Listen for history.replaceState/pushState changes
    window.addEventListener('popstate', this.updateZettelSlugs.bind(this));

    // Listen for custom events from URLManager
    window.addEventListener('url:updated', this.updateZettelSlugs.bind(this));

    // Track history.replaceState/pushState
    this.monitorHistoryChanges();
  }

  disconnect() {
    // Clean up event listeners
    window.removeEventListener('popstate', this.updateZettelSlugs.bind(this));
    window.removeEventListener('url:updated', this.updateZettelSlugs.bind(this));

    // Restore original history methods
    if (this.originalReplaceState) {
      history.replaceState = this.originalReplaceState;
    }
    if (this.originalPushState) {
      history.pushState = this.originalPushState;
    }
  }

  async toggle(event) {
    event.preventDefault();
    this.paneTarget.classList.toggle("visible");
  }

  updateZettelSlugs(event) {
    if (!this.hasZettelSlugsTarget) return;

    // If we received slugs directly from the custom event, use them
    if (event && event.type === 'url:updated' && event.detail && event.detail.slugs) {
      this.zettelSlugsTarget.value = JSON.stringify(event.detail.slugs);
      return;
    }

    // Otherwise extract from URL
    const url = new URL(window.location.href);
    const slugs = [];

    // Extract the main zettel slug from the URL path
    const mainSlugMatch = url.pathname.match(/\/zettel\/(z[a-zA-Z0-9]{22})/);
    if (mainSlugMatch && mainSlugMatch[1]) {
      slugs.push(mainSlugMatch[1]);
    }

    // Get the stacked params
    const stackedParams = url.searchParams.getAll('stacked');
    stackedParams.forEach(slug => {
      if (/^z[a-zA-Z0-9]{22}$/.test(slug)) {
        slugs.push(slug);
      }
    });

    // Update the hidden field value
    this.zettelSlugsTarget.value = JSON.stringify(slugs);
  }

  monitorHistoryChanges() {
    // Save original methods
    this.originalReplaceState = history.replaceState;
    this.originalPushState = history.pushState;

    // Wrap replaceState
    history.replaceState = (state, title, url) => {
      this.originalReplaceState.call(history, state, title, url);
      this.updateZettelSlugs();
    };

    // Wrap pushState
    history.pushState = (state, title, url) => {
      this.originalPushState.call(history, state, title, url);
      this.updateZettelSlugs();
    };
  }
}
